import { useEffect, useState } from 'react';

const QUERY = '(max-width: 767px)';

/** True on phone-sized screens; follows rotation and window resizing. */
export default function useMobile() {
  const [mobile, setMobile] = useState(() => window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const change = (e) => setMobile(e.matches);
    mq.addEventListener('change', change);
    return () => mq.removeEventListener('change', change);
  }, []);
  return mobile;
}
